// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-7cead6ba] {\n  color: #475569;\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
